<!--<div class="container-fluid">-->
<!--  <div class="row no-gutters">-->
<!--    <div class="col-12 col-md-6">-->
<!--      <div class="authentication-page-content p-4 d-flex align-items-center min-vh-100">-->
<!--        <div class="w-100">-->
<!--          <div class="row justify-content-center">-->
<!--            <div class="col-lg-9">-->

<!--              <div>-->
<!--                <div class="text-center" [formGroup]="dataForm">-->
<!--                  <div>-->
<!--                    <a href="javascript:void(0)" class="logo"><img src="assets/Logo-1.png" class="logo-img" alt="logo"></a>-->
<!--                  </div>-->

<!--                  <h4 class="font-size-18 mt-2 welcome-text"><b>Welcome to Gypsee ai !</b></h4>-->
<!--                  <div class="  ml-sm-5 mr-sm-5">-->
<!--                    <div class="mt-3">-->
<!--                      <mat-form-field class="col-12 p-0">-->
<!--                        <mat-label>User Type</mat-label>-->
<!--                        <mat-select formControlName="type">-->
<!--                          <mat-option *ngFor="let ut of userTypes" [value]="ut.type">-->
<!--                            {{ut.title}}-->
<!--                          </mat-option>-->
<!--                        </mat-select>-->
<!--                      </mat-form-field>-->
<!--                      <button class="btn btn-outline-secondary bg-white btn-block text-dark signin-border5  font-custom"-->
<!--                              (click)="signInWithGoogle()"><img-->
<!--                        width="20px"-->
<!--                        style="margin-bottom:3px; margin-right:5px;"-->
<!--                        alt="Google sign-in"-->
<!--                        src="assets/google_logo.png"/>-->
<!--                        Sign In with Google-->
<!--                      </button>-->
<!--                    </div>-->
<!--                    <div class="text-center m-2">Or</div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <form [formGroup]="otpForm" (ngSubmit)="onSubmit()"  class="ml-sm-5 mr-sm-5">-->

<!--                  <div class="">-->
<!--                    <input type="text" placeholder="Enter Registered Number" class="form-control input-border"-->
<!--                           formControlName="userPhoneNumber" mask="0000000000">-->
<!--                    <div class="text-right pt-1" *ngIf="isOTPSent">-->
<!--                      <p><a href="javascript:void(0)" (click)="this.sendOTP()">Click here</a> to resend OTP </p>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                  <div class="pt-2 " *ngIf="isOTPSent">-->
<!--                    <input type="text" placeholder="Enter OTP" class="form-control"-->
<!--                           formControlName="otp" #otpInput>-->
<!--                  </div>-->
<!--                  <div class=" mt-4">-->
<!--                    <button class="btn btn-block btn-primary waves-effect waves-light submit-btn" type="submit">Continue</button>-->
<!--                  </div>-->
<!--                </form>-->
<!--                <div class="mt-5 text-center">-->
<!--                  <p>© 2021 Gypsee. Crafted with <i class="mdi mdi-heart text-danger"></i> by Team Gypsee</p>-->
<!--                </div>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->

<!--    </div>-->
<!--    <div class="col-md-6 d-none d-md-block">-->
<!--      <div class="login-image"></div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--<div class="container col-12 d-flex justify-content-center align-items-center">-->
<!--  <div class="card shadow col-md-4">-->
<!--    <div class="p-3">-->
<!--      <div class="text-center" [formGroup]="dataForm">-->
<!--        <div>-->
<!--          <a href="javascript:void(0)" class="logo"><img src="assets/Logo-1.png" class="logo-img" alt="logo"></a>-->
<!--        </div>-->
<!--        <div class="d-flex justify-content-center">-->
<!--          <div class=" col-12 col-md-10">-->
<!--            <h4 class="font-size-18 mt-2 welcome-text"><b>Welcome to Gypsee ai !</b></h4>-->
<!--            <div class="">-->
<!--              <div class="mt-3">-->
<!--                <mat-form-field class="col-12 p-0">-->
<!--                  <mat-label>User Type</mat-label>-->
<!--                  <mat-select formControlName="type">-->
<!--                    <mat-option *ngFor="let ut of userTypes" [value]="ut.type">-->
<!--                      {{ut.title}}-->
<!--                    </mat-option>-->
<!--                  </mat-select>-->
<!--                </mat-form-field>-->
<!--                <button class="btn btn-outline-secondary bg-white btn-block text-dark signin-border5  font-custom"-->
<!--                        (click)="signInWithGoogle()"><img-->
<!--                  width="20px"-->
<!--                  style="margin-bottom:3px; margin-right:5px;"-->
<!--                  alt="Google sign-in"-->
<!--                  src="assets/google_logo.png"/>-->
<!--                  Sign In with Google-->
<!--                </button>-->
<!--              </div>-->
<!--              <div class="text-center m-2">Or</div>-->
<!--              <form [formGroup]="otpForm" (ngSubmit)="onSubmit()" class="">-->

<!--                <div class="">-->
<!--                  <mat-form-field appearance="legacy" class="col-12 p-0 m-0">-->
<!--                    <mat-label>Mobile Number</mat-label>-->
<!--                    <input matInput type="text" placeholder="Enter Registered Number" class="form-control"-->
<!--                           formControlName="userPhoneNumber" mask="0000000000">-->
<!--                    <mat-icon matPrefix class="pr-2">call</mat-icon>-->
<!--                    <mat-hint class="text-right" *ngIf="isOTPSent">-->
<!--                      <a href="javascript:void(0)" (click)="this.sendOTP()">Click here</a> to resend OTP-->
<!--                    </mat-hint>-->
<!--                  </mat-form-field>-->
<!--                  &lt;!&ndash;                  <input type="text" placeholder="Enter Registered Number" class="form-control input-border"&ndash;&gt;-->
<!--                  &lt;!&ndash;                         formControlName="userPhoneNumber" mask="0000000000">&ndash;&gt;-->
<!--                  &lt;!&ndash;                  <div class="text-right pt-1" *ngIf="isOTPSent">&ndash;&gt;-->
<!--                  &lt;!&ndash;                    <p><a href="javascript:void(0)" (click)="this.sendOTP()">Click here</a> to resend OTP </p>&ndash;&gt;-->
<!--                  &lt;!&ndash;                  </div>&ndash;&gt;-->
<!--                </div>-->
<!--                <div class="pt-2 " *ngIf="isOTPSent">-->
<!--                  <mat-form-field appearance="legacy" class="col-12 p-0 m-0">-->
<!--                    <mat-label>OTP</mat-label>-->
<!--                    <input type="text" matInput placeholder="Enter OTP" class="form-control"-->
<!--                           formControlName="otp" #otpInput>-->
<!--                    <mat-icon matPrefix class="pr-2">remove_red_eye</mat-icon>-->
<!--                  </mat-form-field>-->

<!--                </div>-->
<!--                <div class=" mt-3">-->
<!--                  <button class="btn btn-block btn-grad " type="submit">Continue-->
<!--                  </button>-->
<!--                </div>-->
<!--              </form>-->
<!--              <div class="mt-3 text-center">-->
<!--                <p>© 2021 Gypsee. Crafted with <i class="mdi mdi-heart text-danger"></i> by Team Gypsee</p>-->
<!--              </div>-->

<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
<!--  </div>-->
<!--</div>-->

<!--New Login begins-->

<div class="limiter">
  <div class="container-login100">
    <div class="wrap-login100 p-l-55 p-r-55 pt-4 pb-3">
      <form
        class="login100-form validate-form"
        [formGroup]="otpForm"
        (ngSubmit)="onSubmit()"
      >
        <span class="login100-form-title pb-3">
          <a href="javascript:void(0)" class="logo"
            ><img src="assets/Logo-2.png" class="logo-img" alt="logo"
          /></a>
        </span>

        <div class="wrap-input100 validate-input m-b-23">
          <!-- <span class="label-input100">User Type</span> -->
          <mat-form-field class="col-12 pr-0 mb-2">
            <mat-select formControlName="type" placeholder="Select User Type">
              <mat-option *ngFor="let ut of userTypes" [value]="ut.type">
                {{ ut.title }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="row">
          <div
            class="wrap-input100 validate-input col-4"
            data-validate="Country is reauired"
          >
            <span class="label-input100">Country Code</span>
            <input
              class="input100"
              type="text"
              inputmode="numeric"
              placeholder="Country Code"
              formControlName="countryCode"
              mask="+XX"
            />
            <span class="focus-input100" data-symbol="+"></span>
          </div>

          <div
            class="wrap-input100 validate-input col-8"
            data-validate="Mobile is reauired"
          >
            <span class="label-input100">Mobile Number</span>
            <input
              class="input100"
              type="text"
              inputmode="numeric"
              placeholder="Enter Registered Number"
              formControlName="userPhoneNumber"
              mask="0000000000"
            />
            <span class="focus-input100" data-symbol="&#xf206;"></span>
          </div>
          <div class="d-flex justify-content-end col-12" *ngIf="isOTPSent">
            <mat-hint class="text-right float-right ml-auto mr-0">
              <a
                href="javascript:void(0)"
                class="text-primary"
                (click)="this.sendOTP()"
                >Click here</a
              >
              to resend OTP
            </mat-hint>
          </div>
        </div>

        <div
          *ngIf="isOTPSent"
          class="wrap-input100 validate-input"
          data-validate="OTP is required"
        >
          <span class="label-input100">OTP</span>
          <input
            class="input100"
            type="text"
            inputmode="numeric"
            matInput
            placeholder="Enter OTP"
            formControlName="otp"
            #otpInput
          />
          <span class="focus-input100" data-symbol="&#xf190;"></span>
        </div>

        <button class="login-btn">Login</button>

        <!-- <div class="container-login100-form-btn pt-3">
          <div class="wrap-login100-form-btn">
            <div class="login100-form-bgbtn"></div>
            <button class="login100-form-btn">
              Login
            </button>
          </div>
        </div> -->

        <div class="txt1 text-center pt-4 pb-3">
          <span> Or Sign In Using </span>
        </div>

        <div class="flex-c-m">
          <div class="g-login-btn" (click)="signInWithGoogle()">
            <img src="assets/g-icon.svg" height="35" />
          </div>
          <!-- <a href="javascript:void(0)" (click)="signInWithGoogle()" class="login100-social-item bg3 text-white">
            <i class="fa fa-google"></i>
          </a> -->
        </div>

        <div class="flex-col-c pt-2">
          <span class="txt1">
            © 2024 Gypsee. Crafted with
            <i class="mdi mdi-heart text-danger"></i> by Team Gypsee
          </span>
        </div>
      </form>
    </div>
  </div>
</div>

<div id="dropDownSelect1"></div>

<!--===============================================================================================-->
<!--New Login ends-->
